// extracted by mini-css-extract-plugin
export default {"TOP":"MiddleSection_TOP__7qtpC","Container":"MiddleSection_Container__ziV1H"};